import { cn } from "@omni/utils/styles";

type InfoBlockAnchorProps = {
    id: string;
};

const InfoBlockAnchor = ({ id }: InfoBlockAnchorProps) => {
    return (
        <span
            id={id}
            className={cn(
                "tw:float-left tw:h-0 tw:-mt-1 tw:invisible tw:lg:-mt-[15px]"
            )}
        ></span>
    );
};

export { InfoBlockAnchor };
